var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{ light: !_vm.dark, dark: _vm.dark }},[_c('v-icon',{staticClass:"spin"},[_vm._v(" mdi-"+_vm._s(_vm.icon === "default" || !_vm.icon ? "autorenew" : _vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }